import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ErrorBoundary } from './components/ErrorBoundary';
import Home from './pages/Home';
import Login from './pages/Login';
import Profile from './pages/Profile';
import HesapSil from './pages/HesapSil';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import ChildSafety from './pages/ChildSafety';
import ContentDetail from './pages/ContentDetail';
import ResetPassword from './pages/ResetPassword';
import NotFoundPage from './pages/NotFoundPage';

export default function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/giris" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/profil" element={<Profile />} />
            <Route path="/hesap-sil" element={<HesapSil />} />
            <Route path="/privacy" element={<PrivacyPolicy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="/child-safety" element={<ChildSafety />} />
            <Route path="/icerikler" element={<ContentDetail />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ErrorBoundary>
  );
}
